import axios from 'axios'
import { CommonMostLikelyMorphologicCodeResponse } from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'

class CommonMostLikelyMorphologicCodeService {
    async getMostLikelyMorphologicCodes(): Promise<CommonMostLikelyMorphologicCodeResponse[]> {
        const response =
            await axios.get<CommonMostLikelyMorphologicCodeResponse[]>(
                `/mostLikelyMorphologicCodes/`)
        return response.data
    }
}
export const commonMostLikelyMorphologicCodeService = new CommonMostLikelyMorphologicCodeService()
